import React, { Fragment } from 'react';
import { number, oneOfType, string } from 'prop-types';
import Fade from '@material-ui/core/Fade';
import Base, { CopyContainer, FADE_TIMEOUT, H2, Icon, ImgContainer, P, Root } from '../Base';
import { isEmpty } from '../../../../../../../core/util/empty';
import { hasNoLimit } from '../../../util/insuranceDetails';

// @ts-expect-error ts-migrate(2417) FIXME: Type '{ carrier: Validator<string>; planName: Vali... Remove this comment to see the full error message
class ExplanationPlanTypePpo extends Base {
  static propTypes = {
    carrier: string.isRequired,
    planName: string.isRequired,
    planType: string.isRequired,
    deductibleAmountIndividualInNetwork: oneOfType([number, string]).isRequired,
  };

  static isVisible = ({ planType }: any) => !isEmpty(planType) && planType.toUpperCase() === 'PPO';

  icon = '/images/insurance_tutorial/03_ppo_hmo.svg';

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'deductibleAmountIndividualInNetwork' doe... Remove this comment to see the full error message
  hasNoDeductible = () => hasNoLimit(this.props.deductibleAmountIndividualInNetwork);

  render = () => {
    const {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'carrier' does not exist on type 'Readonl... Remove this comment to see the full error message
      carrier,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'deductibleAmountIndividualInNetwork' doe... Remove this comment to see the full error message
      deductibleAmountIndividualInNetwork,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'outOfPocketMax' does not exist on type '... Remove this comment to see the full error message
      outOfPocketMax,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'planName' does not exist on type 'Readon... Remove this comment to see the full error message
      planName,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'planType' does not exist on type 'Readon... Remove this comment to see the full error message
      planType,
    } = this.props;
    return (
      <Fade in timeout={FADE_TIMEOUT}>
        <Root>
          <ImgContainer>
            <Icon src={this.icon} />
          </ImgContainer>

          <CopyContainer>
            <H2>You have a PPO</H2>

            <P>
              Your <b>{this.getCarrierNameTypeString({ carrier, planName, planType })}</b> plan
              allows you to visit most doctors in the <b>{carrier}</b> network&mdash;no referral
              required. It's got lots of flexibility.
            </P>

            <P>
              Try to visit doctors in the <b>{carrier}</b> network. Why? You'll pay less. Going to
              an out-of-network doctor is often more expensive, and doesn't count towards your{' '}
              {this.hasNoDeductible() && (
                <>
                  <b>${outOfPocketMax}</b> out-of-pocket max.
                </>
              )}
              {!this.hasNoDeductible() && (
                <>
                  <b>${deductibleAmountIndividualInNetwork}</b> in-network deductible.
                </>
              )}
            </P>
          </CopyContainer>
        </Root>
      </Fade>
    );
  };
}

export default ExplanationPlanTypePpo;
